import { EnvironmentType } from "@app-context/environments/context";
import { restServerBase } from "@app-utils/restServer";
import { useRefCallback } from "@enfusion-ui/hooks";
import { useWorkerModule } from "@enfusion-ui/web-workers";
import { noop } from "lodash";
import * as React from "react";

import { NetworkCallsContext } from "./context";
import { APISource, SocketType } from "./types";

export const NetworkCallsProvider: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const { enableModule } = useWorkerModule("socket");

  React.useEffect(() => {
    enableModule();
  }, []);

  const subscribeSocket = useRefCallback(
    (
      _env: EnvironmentType,
      _type: SocketType,
      _source: APISource,
      _onMessage: (message: string) => void
    ) => {
      return {
        unsubscribe: noop,
        postMessage: noop,
      };
    },
    []
  );

  const fetchCall = useRefCallback(function <T = string>(
    env: EnvironmentType,
    endpoint: string,
    params?: Record<string, unknown>
  ) {
    return restServerBase<T>(endpoint, env.restAPIUrl, params);
  },
  []);

  return (
    <NetworkCallsContext.Provider
      value={{
        fetchCall,
        subscribeSocket,
      }}
    >
      {children}
    </NetworkCallsContext.Provider>
  );
};
